export default __webpack_public_path__ + "static/media/sam.ec94e9a9.jpeg";